// extracted by mini-css-extract-plugin
module.exports = {"deleteBtn":"DeleteButton_deleteBtn__27SUw"};